import { BaseEdge, EdgeProps, getStraightPath } from '@xyflow/react';
import { memo } from 'react';
import { getAnimatedDotRadius } from '../helpers/edges.helpers';

const WorkflowEdgeIn = memo(({ sourceX, sourceY, targetX, targetY, style = {}, markerEnd }: EdgeProps) => {
  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <circle r={getAnimatedDotRadius(style.strokeWidth)} fill={style.stroke}>
        <animateMotion dur="2s" repeatCount="indefinite" path={edgePath} begin={`${Math.random() * 2}s`} />
      </circle>
    </>
  );
});

const WorkflowEdgeOut = memo(({ sourceX, sourceY, targetX, targetY, style = {}, markerEnd }: EdgeProps) => {
  const [edgePath] = getStraightPath({
    sourceX,
    sourceY,
    targetX,
    targetY,
  });

  return (
    <>
      <BaseEdge path={edgePath} markerEnd={markerEnd} style={style} />
      <circle r={getAnimatedDotRadius(style.strokeWidth)} fill={style.stroke}>
        <animateMotion dur="2s" repeatCount="indefinite" path={edgePath} begin={`${Math.random() * 2}s`} />
      </circle>
    </>
  );
});

export { WorkflowEdgeIn, WorkflowEdgeOut };
